import { render, staticRenderFns } from "./chooseUser.vue?vue&type=template&id=610da82c&scoped=true"
import script from "./chooseUser.vue?vue&type=script&lang=js"
export * from "./chooseUser.vue?vue&type=script&lang=js"
import style0 from "./chooseUser.vue?vue&type=style&index=0&id=610da82c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610da82c",
  null
  
)

export default component.exports